export default __webpack_public_path__ + "static/media/3 (1000).6475fdf9.jpg";